module.exports = __webpack_public_path__ + "static/img/craftsman.4bd21f18.png";